module.exports = "/_next/static/images/CardProfile-dec18f1a1ed27876486150c11d8d4f69.webp";